import { Workspace } from "../models";

export const isFreePlan = (workspace?: Workspace) => {
  return !Boolean(workspace?.subscription_plans.find((item) => item.type === "plan") || workspace?.is_free);
};
